module.exports = __webpack_public_path__ + "img/menu22.4565dca0.png";